import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FilesService } from '../../../core/services/files.service';
import { FleetService } from '../../../core/services/fleet.service';
import { DatePipe } from '@angular/common';
import { NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { InventoryService } from '../../../core/services/inventory.service';
import { AuthService } from '../../../modules/auth/services/auth.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { IDeactivateComponent } from '../../../core/guards/deactivate.gaurd';
import { Observable } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';

const INVENTORY_DAMAGE_UPLOAD = 'INVENTORY_DAMAGE_UPLOAD';

interface Params {
  parameter: string;
  // Add other properties if needed
}

@Component({
  selector: 'app-add-edit-inventory',
  templateUrl: './add-edit-inventory.component.html',
  styleUrls: ['./add-edit-inventory.component.scss'],
})
export class AddEditInventoryComponent implements OnInit, IDeactivateComponent {
  @ViewChild('image', { static: false }) image!: ElementRef;
  comment = '';
  damageImgUploading = false;
  currentFix = 0;
  tempEditData: any;
  tempNumber = 0;
  modalStatus = 'add';
  formattedDate: any;
  inspectionForm: FormGroup | any;
  formErrors: any;
  markers: {
    x: number;
    y: number;
    number: number;
    origin: string;
    damageType: string;
    description: string;
    files: any;
    status?: any;
    comment?: any;
  }[] = [];
  markerNumber = 1;
  isVisible = false;
  isVisibleCom = false;
  tempMouseEvent: any;
  damageType = '';
  damageDesc = '';
  damageFiles: any[] = [];
  breadcrumbs: any[] = [];
  selectedBooking: any;
  afterId = '';
  fleetId: any;
  reason = '';
  prevRecord: any;
  fleetData = {
    vehicleDetails: {
      vehicleModel: '',
      registrationNumber: '',
    },
  };
  fleetBookingsLoading = false;
  beforeData: any;
  params: Params = {
    parameter: 'someValue',
    // Initialize other properties as needed
  };
  panels = [
    {
      active: true,
      name: 'This is panel header 1',
      disabled: false,
    },
  ];
  bookingOptions: any[] = [];
  parameter!: string;
  user: any;
  submit = false;
  loading = false;
  prevPage = '';
  rentBookingId = '';
  haveRec: any;

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any): string | undefined {
    const confirmationMessage =
      'You have unsaved changes. Do you really want to leave?';
    $event.returnValue = confirmationMessage; // Standard for most browsers
    return confirmationMessage; // For some older browsers
  }

  // formatterPercentFuel = (value: number): string => `${value} %`;
  // parserPercentFuel = (value: string): string => value.replace(' %', '');
  // formatterDistance = (value: number): string => `${value} KM`;
  // parserDistance = (value: string): string => value.replace(' KM', '');

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private filesService: FilesService,
    private fleetService: FleetService,
    private inventoryService: InventoryService,
    private router: Router,
    private authService: AuthService,
    private message: NzMessageService,
  ) {}

  ngOnInit(): void {
    this.uploadLoader();
    this.user = this.authService.getLoggedInUser();
    this.setDate();
    this.initInspectionForm();
    this.fleetId = this.route.snapshot.paramMap.get('fleetId');
    this.route.params.subscribe((params) => {
      this.haveRec = params['rec'];
      this.parameter = params['status'];
      this.afterId = params['id'];
      this.prevRecord = params['prevRecId'];
      this.rentBookingId = params['bookingId'];
      if (this.parameter === 'Initial' || this.parameter === ('Final' as any)) {
        this.reason = this.parameter;
        this.inspectionForm.patchValue({
          inspectionDetails: { reason: this.parameter },
        });
      }
      if (this.parameter === 'Rent') {
        this.inspectionForm.patchValue({
          inspectionDetails: { reason: this.parameter },
        });
      }
      if (this.afterId && this.parameter === 'After') {
        this.loading = true;
        this.inventoryService.getInventoryById(this.afterId).then((res) => {
          this.beforeData = res;
          console.log(this.beforeData);
          this.markers = this.beforeData.before.damages;
          this.markerNumber = this.beforeData.before.damages.length + 1;
          this.inspectionForm.patchValue({
            inspectionDetails: {
              reason: this.beforeData.before.inspectionDetails.reason,
            },
          });
          if (this.beforeData.before.inspectionDetails.reason === 'Other') {
            this.inspectionForm.patchValue({
              inspectionDetails: {
                otherReason:
                  this.beforeData.before.inspectionDetails.otherReason,
              },
            });
            this.inspectionForm.get('inspectionDetails.otherReason').disable();
          }
          this.inspectionForm.patchValue({
            inspectionDetails: {
              bookingDetails:
                this.beforeData.before.inspectionDetails.bookingDetails,
            },
          });
          this.inspectionForm.patchValue({
            beforeInfo: this.beforeData.before.recordInformation,
          });
          this.loading = false;
        });
      }
      // if (this.afterId && this.parameter === 'After') {
      //   this.inventoryService.getInventoryById(this.afterId).then((res) => {
      //     this.inspectionForm.patchValue({
      //       beforeInfo: this.beforeData.before.recordInformation,
      //     });
      //   });
      // }
    });

    if (this.prevRecord && this.parameter === 'Before') {
      this.loading = true;
      this.inventoryService.getInventoryById(this.prevRecord).then((res) => {
        this.beforeData = res;
        console.log('HIii', this.beforeData);
        if (this.beforeData.before.inspectionDetails.reason === 'Initial') {
          this.markers = this.beforeData.before.damages;
          this.markerNumber = this.beforeData.before.damages.length + 1;
          this.inspectionForm.patchValue({
            recordInformation: this.beforeData.before.recordInformation,
          });
        } else {
          this.markers = this.beforeData.after.damages;
          this.markerNumber = this.beforeData.after.damages.length + 1;
          this.inspectionForm.patchValue({
            recordInformation: this.beforeData.after.recordInformation,
          });
        }
        this.loading = false;
      });
    }

    if (this.prevRecord && this.parameter === 'Final') {
      this.loading = true;
      this.inventoryService.getInventoryById(this.prevRecord).then((res) => {
        this.beforeData = res;
        console.log(this.beforeData);
        if (this.haveRec) {
          this.markers = this.beforeData.before.damages;
          this.markerNumber = this.beforeData.before.damages.length + 1;
          this.inspectionForm.patchValue({
            beforeInfo: this.beforeData.before.recordInformation,
          });
        } else {
          this.markers = this.beforeData.after.damages;
          this.markerNumber = this.beforeData.after.damages.length + 1;
          this.inspectionForm.patchValue({
            beforeInfo: this.beforeData.after.recordInformation,
          });
        }
        this.loading = false;
      });
    }

    this.fleetService.getOneFleetById(this.fleetId).then((res) => {
      this.fleetData = res;
      this.breadcrumbs = [
        {
          title: 'Fleets',
          icon: 'car',
          route: '/admin/fleets',
        },
        {
          title: this.fleetData.vehicleDetails?.registrationNumber,
        },
        {
          title: ' Inventory Records ',
          route: [
            `/admin/fleets/${this.fleetId}`,
            { pageName: 'fleetInventory' },
          ],
        },
        {
          title: ' Add ',
        },
      ];
    });

    this.setContainerWidth();
  }

  uploadLoader() {
    this.filesService.fileUploadingSubject.subscribe((res: any) => {
      switch (res.type) {
        case INVENTORY_DAMAGE_UPLOAD:
          this.damageImgUploading = res.loading;
          break;
      }
    });
  }

  initInspectionForm(): void {
    this.inspectionForm = this.fb.group({
      inspectionDetails: this.fb.group({
        reason: [null, Validators.required],
        otherReason: [null],
        bookingDetails: this.fb.group({
          booking: [null, []],
          bookingId: [null, []],
          type: [null, []],
        }),
        Odometer: [0, Validators.required],
        fuelLevel: [0, Validators.required],
      }),
      recordInformation: this.fb.group({
        functioning: [true],
        malfunctioning: [false],
        dashboard: [false],
        leftMirror: [false],
        rightMirror: [false],
        lighter: [false],
        reverseCam: [false],
        sensors: [false],
        keys: [false],
        radio: [false],
        bluetooth: [false],
        ac: [false],
        LicenceInsuranceEco: [false],
        sunShades: [false],
        wiperBlades: [false],
        horn: [false],
        lFrontLight: [false],
        rFrontLight: [false],
        lHeadLight: [false],
        rHeadLight: [false],
        lFogLight: [false],
        rFogLight: [false],
        otherToolKit: [false],
        lSignalLight: [false],
        rSignalLight: [false],
        lWinker: [false],
        rWinker: [false],
        lRearLight: [false],
        rRearLight: [false],
        lBreakLight: [false],
        rBreakLight: [false],
        RearRoofLight: [false],
        originalCarpets: [false],
        mCarpets: [false],
        badges: [false],
        wheelCaps: [false],
        hubCaps: [false],
        innerMudGaurd: [false],
        spareWheel: [false],
        jackAndHandle: [false],
        wheelBrush: [false],
        electricAirPump: [false],
        tyreGlue: [false],
      }),
      beforeInfo: this.fb.group({
        dashboard: [false],
        leftMirror: [false],
        rightMirror: [false],
        lighter: [false],
        reverseCam: [false],
        sensors: [false],
        keys: [false],
        radio: [false],
        bluetooth: [false],
        ac: [false],
        LicenceInsuranceEco: [false],
        sunShades: [false],
        wiperBlades: [false],
        horn: [false],
        lFrontLight: [false],
        rFrontLight: [false],
        lHeadLight: [false],
        rHeadLight: [false],
        lFogLight: [false],
        rFogLight: [false],
        otherToolKit: [false],
        lSignalLight: [false],
        rSignalLight: [false],
        lWinker: [false],
        rWinker: [false],
        lRearLight: [false],
        rRearLight: [false],
        lBreakLight: [false],
        rBreakLight: [false],
        RearRoofLight: [false],
        originalCarpets: [false],
        mCarpets: [false],
        badges: [false],
        wheelCaps: [false],
        hubCaps: [false],
        innerMudGaurd: [false],
        spareWheel: [false],
        jackAndHandle: [false],
        wheelBrush: [false],
        electricAirPump: [false],
        tyreGlue: [false],
      }),
      remarks: this.fb.group({
        remark: [null],
      }),
    });
  }

  getBookingsByFleet(event: string): void {
    if (event === 'Rent' || event === 'Transfer' || event === 'Office Use') {
      this.fleetBookingsLoading = true;
      this.fleetService
        .getAllBookingsByFleet(this.fleetId)
        .subscribe((res: any) => {
          this.fleetBookingsLoading = false;
          this.bookingOptions = res;
          if (event === 'Office Use') {
            this.bookingOptions = this.bookingOptions.filter((item) =>
              ['Other'].includes(item.type),
            );
          } else if (event === 'Transfer') {
            this.bookingOptions = this.bookingOptions.filter((item) =>
              ['Transfer'].includes(item.type),
            );
          } else {
            this.bookingOptions = this.bookingOptions.filter((item) =>
              ['Rent'].includes(item.type),
            );
          }
          console.log(this.bookingOptions);
          if (this.parameter === 'After') {
            this.setBookingDetails(
              this.beforeData?.before?.inspectionDetails?.bookingDetails
                ?.booking,
            );
          }
        });

      this.inspectionForm
        .get('inspectionDetails.bookingDetails.booking')
        .addValidators(Validators.required);
      this.inspectionForm
        .get('inspectionDetails.bookingDetails.type')
        .addValidators(Validators.required);
      this.inspectionForm
        .get('inspectionDetails.bookingDetails.booking')
        .updateValueAndValidity({ emitEvent: false, onlySelf: true });
      this.inspectionForm
        .get('inspectionDetails.bookingDetails.type')
        .updateValueAndValidity({ emitEvent: false, onlySelf: true });
    } else {
      this.inspectionForm
        .get('inspectionDetails.bookingDetails.booking')
        .clearValidators();
      this.inspectionForm
        .get('inspectionDetails.bookingDetails.type')
        .clearValidators();
      this.inspectionForm.get('inspectionDetails.bookingDetails').reset();
      this.inspectionForm
        .get('inspectionDetails.bookingDetails.booking')
        .updateValueAndValidity({ emitEvent: false, onlySelf: true });
      this.inspectionForm
        .get('inspectionDetails.bookingDetails.type')
        .updateValueAndValidity({ emitEvent: false, onlySelf: true });
      this.selectedBooking = null;
    }
  }

  setBookingDetails(event: string): void {
    console.log();
    this.selectedBooking = this.bookingOptions?.find(
      (op: any) => op._id === event,
    );
    this.inspectionForm.patchValue({
      inspectionDetails: {
        bookingDetails: {
          bookingId: this.selectedBooking.refNo,
          type: this.selectedBooking?.type,
        },
      },
    });
  }

  showModal(event: MouseEvent): void {
    this.tempMouseEvent = event;
    this.isVisible = true;
  }

  handleOk(event: MouseEvent): void {
    this.placeMarker(event);
    this.isVisible = false;
  }

  handleCancel(): void {
    this.modalStatus = 'add';
    this.damageType = '';
    this.damageDesc = '';
    this.damageFiles = [];
    this.isVisible = false;
  }

  damageUpload = (item: NzUploadXHRArgs) =>
    this.filesService
      .postFile(item.file, INVENTORY_DAMAGE_UPLOAD)
      .subscribe((res) => {
        this.message.create('success', `Attachment has been uploaded!`);
        const data = res as any;
        this.damageFiles.push({ name: item.file.name, url: data.url });
        this.filesService.fileUploadingSubject.next({
          type: INVENTORY_DAMAGE_UPLOAD,
          loading: false,
        });
      });

  onFileSelected(event: any) {
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      const file: File = files[0];
      this.filesService
        .postFile(file, INVENTORY_DAMAGE_UPLOAD)
        .subscribe((res) => {
          this.message.create('success', `Attachment has been uploaded!`);
          const data = res as any;
          this.damageFiles.push({ name: file.name, url: data.url });
          this.filesService.fileUploadingSubject.next({
            type: INVENTORY_DAMAGE_UPLOAD,
            loading: false,
          });
        });
    }
  }

  triggerFileInput() {
    console.log('triggered');
    document.getElementById('fileInput')?.click(); // Trigger click event on file input
  }

  placeMarker(event: MouseEvent) {
    const imageElement: HTMLImageElement = this.image.nativeElement;
    const rect = imageElement.getBoundingClientRect();

    const markerX = ((event.clientX - rect.left) / rect.width) * 100;
    const markerY = ((event.clientY - rect.top) / rect.height) * 100;
    this.message.create('success', `New damage has been added!`);
    this.markers.push({
      x: markerX,
      y: markerY,
      origin: '',
      number: this.markerNumber,
      damageType: this.damageType,
      description: this.damageDesc,
      files: this.damageFiles,
      status: true,
    });
    this.markerNumber++;
    this.damageType = '';
    this.damageDesc = '';
    this.damageFiles = [];
  }

  setContainerWidth() {
    const imageElement: HTMLImageElement = this.image?.nativeElement;
    const containerElement: HTMLElement | null =
      document.querySelector('.image-container');

    if (containerElement) {
      containerElement.style.width = imageElement.naturalWidth + 'px';
    }
  }

  setDate(): void {
    const currentDate = new Date();
    const datePipe = new DatePipe('en-US');
    this.formattedDate = datePipe.transform(currentDate, 'dd-MM-yyyy');
  }

  onSubmit(): void {
    this.inspectionForm.get('inspectionDetails.otherReason').enable();
    const tempReason = this.inspectionForm.get(
      'inspectionDetails.reason',
    ).value;
    if (this.parameter === 'Initial' || this.parameter === 'Before') {
      if (this.parameter === 'Initial' || this.parameter === ('Final' as any)) {
        this.inspectionForm.patchValue({
          inspectionDetails: { reason: this.parameter },
        });
      }
      this.setDamageOrigin();

      this.inventoryService
        .createInventory({
          fleet: this.fleetId,
          bookingReference: '324324324',
          before: {
            ...this.inspectionForm.value,
            damages: this.markers,
            date: new Date(),
            user: {
              name: this.user.firstname + ' ' + this.user.lastname,
              id: this.user.userId,
            },
          },
          updateType: this.parameter,
        })
        .then((res) => {
          if (tempReason === 'Rent') {
            this.fleetService
              .updateFleet({
                _id: this.fleetId,
                currentMileage: this.inspectionForm.get(
                  'inspectionDetails.Odometer',
                ).value,
                currentFuelLevel: this.inspectionForm.get(
                  'inspectionDetails.fuelLevel',
                ).value,
              })
              .then(() => {
                if (this.rentBookingId) {
                  this.router.navigate([
                    `/admin/booking-rent/${this.rentBookingId}`,
                    {},
                  ]);
                }
              });
          } else if (tempReason === 'Transfer') {
            this.fleetService.updateFleet({
              _id: this.fleetId,
              currentMileage: this.inspectionForm.get(
                'inspectionDetails.Odometer',
              ).value,
              currentFuelLevel: this.inspectionForm.get(
                'inspectionDetails.fuelLevel',
              ).value,
            });
          } else if (tempReason === 'Service') {
            this.fleetService.updateFleet({
              _id: this.fleetId,
              currentMileage: this.inspectionForm.get(
                'inspectionDetails.Odometer',
              ).value,
              currentFuelLevel: this.inspectionForm.get(
                'inspectionDetails.fuelLevel',
              ).value,
            });
          } else if (tempReason === 'Office Use') {
            this.fleetService.updateFleet({
              _id: this.fleetId,
              currentMileage: this.inspectionForm.get(
                'inspectionDetails.Odometer',
              ).value,
              currentFuelLevel: this.inspectionForm.get(
                'inspectionDetails.fuelLevel',
              ).value,
            });
          } else {
            let payload;
            if (this.parameter === 'Initial') {
              payload = {
                _id: this.fleetId,
                currentMileage: this.inspectionForm.get(
                  'inspectionDetails.Odometer',
                ).value,
                currentFuelLevel: this.inspectionForm.get(
                  'inspectionDetails.fuelLevel',
                ).value,
              };
            } else {
              payload = {
                _id: this.fleetId,
                currentMileage: this.inspectionForm.get(
                  'inspectionDetails.Odometer',
                ).value,
                currentFuelLevel: this.inspectionForm.get(
                  'inspectionDetails.fuelLevel',
                ).value,
              };
            }
            this.fleetService.updateFleet(payload);
          }
          this.submit = true;
          this.router.navigate([
            `/admin/fleets/${this.fleetId}`,
            { pageName: 'fleetInventory' },
          ]);
        });
    } else if (
      this.parameter === 'After' ||
      this.parameter === ('Final' as any)
    ) {
      this.setDamageOrigin();
      this.inventoryService
        .updateInventory({
          _id: this.afterId,
          after: {
            ...this.inspectionForm.value,
            damages: this.markers,
            date: new Date(),
            user: {
              name: this.user.firstname + ' ' + this.user.lastname,
              id: this.user.userId,
            },
          },
          updateType: this.parameter,
        })
        .then((res) => {
          this.fleetService.updateFleet({
            _id: this.fleetId,
            currentMileage: this.inspectionForm.get(
              'inspectionDetails.Odometer',
            ).value,
            currentFuelLevel: this.inspectionForm.get(
              'inspectionDetails.fuelLevel',
            ).value,
          });
          this.submit = true;
          if (this.parameter === 'Final') {
            this.handleOkAddFleetNote();
          } else {
            this.router.navigate([
              `/admin/fleets/${this.fleetId}`,
              { pageName: 'fleetInventory' },
            ]);
          }
        });
    }
  }

  setDamageOrigin(): void {
    if (this.parameter === 'Before' || this.parameter === 'Initial') {
      this.markers.forEach((marker) => {
        marker.origin = 'Before';
      });
    } else if (this.parameter === 'After' || this.parameter === 'Final') {
      this.markers.forEach((marker) => {
        if (marker.origin === '') {
          marker.origin = 'After';
        }
      });
    }
  }

  cancel(): void {}

  confirm(): void {
    this.router.navigate([
      `/admin/fleets/${this.fleetId}`,
      { pageName: 'fleetInventory' },
    ]);
  }

  confirmRemoveAttachment(attachmentId: any): void {
    this.message.create('success', `Attachment has been deleted!`);
    this.damageFiles.splice(attachmentId, 1);
  }

  editDamage(data: any): void {
    this.tempEditData = data.number;
    this.modalStatus = 'edit';
    this.tempNumber = data.number;
    this.damageType = data.damageType;
    this.damageDesc = data.description;
    this.damageFiles = data.files;
    this.isVisible = true;
  }

  updatePanel() {
    this.markers[this.tempEditData - 1].files = this.damageFiles;
    this.markers[this.tempEditData - 1].damageType = this.damageType;
    this.markers[this.tempEditData - 1].description = this.damageDesc;
    this.damageType = '';
    this.damageDesc = '';
    this.damageFiles = [];
    this.modalStatus = 'add';
    this.isVisible = false;
    this.message.create('success', `Damage has been updated!`);
  }

  deleteRecord(id: any): void {
    console.log(this.markers);
    this.markers.splice(id, 1);
    for (let i = 0; i < this.markers.length; i++) {
      this.markers[i].number = i + 1;
    }
    this.markerNumber--;
    this.message.create('success', `Damage has been Deleted!`);
  }

  showModal2(data: any): void {
    this.isVisibleCom = true;
    this.currentFix = data.number - 1;
  }

  handleOk2(): void {
    this.markers[this.currentFix].status = false;
    this.markers[this.currentFix].comment = this.comment;
    this.comment = '';
    this.currentFix = 0;
    this.isVisibleCom = false;
    this.message.create('success', `Damage has been fixed!`);
  }

  handleCancel2(): void {
    this.comment = '';
    this.currentFix = 0;
    this.isVisibleCom = false;
  }

  canExit(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.submit) {
      return true;
    } else if (this.inspectionForm.dirty || this.inspectionForm.touched) {
      return confirm(
        ' You have unsaved changes, Do you really want to discard these changes?',
      );
    } else {
      return true;
    }
  }

  filteredMarkers() {
    return this.markers.filter((panel) => panel.status === true);
  }

  handleOkAddFleetNote(): void {
    this.fleetService
      .createFleetRemark({
        description: 'Reason: Inventory Final Inspection',
        action: 'Deactivated',
        fleet: this.fleetId,
      })
      .then((res) => {
        this.fleetService
          .updateFleet({
            _id: this.fleetId,
            active: false,
          })
          .then(() => {
            this.message.create('success', `Vehicle has been deactivated!`);
            this.router.navigate([
              `/admin/fleets/${this.fleetId}`,
              { pageName: 'fleetInventory' },
            ]);
          });
      });
  }

  openCamera() {}
}
